module.exports = __webpack_public_path__ + "static/media/phone.fc88f16f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone.svg
// module id = 856
// module chunks = 0